/* eslint-disable simple-import-sort/imports */

import './CompteExpert.scss';

import React, { useState,useEffect } from 'react';

import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import DocAdministra from './SideExpertCompteExpert';
import { useLocation, useParams } from 'react-router-dom';

import NavBarDonneeProfile from './NavBarDonneeProfile';
import SocieteGeneralisation from '../../Expert/Profile/SocieteGeneralisation';
import { typeTraitementEnum } from '../../Expert/CompleterProfile/DonneesPersonnelsExpert';
import { getNomPrenomClearFromPersoData } from '../../../Utils/utils';
import useWindowSize from '../../../hooks/useWindowSize';
import { useTranslation } from 'react-i18next';

function SocieteAdmin() {
    const location = useLocation();
    const { i18n } = useTranslation();
    const axiosPrivate = useAxiosPrivate();
    const [dataExpert, setdataExpert] = useState({});
    const {device}=useWindowSize();
    let param = useParams();
    const [nomExpert,setNomExpert]=useState('');
    //PS: help function => get rowdata from backend using ID
    const getExpertbyId = async () => {
        try {
            const response = await axiosPrivate.get('/users/getExpertById/'+param.ExpertId);
            //console.log('Data By ID',response.data);
            setdataExpert(response.data);
            setNomExpert(getNomPrenomClearFromPersoData(response?.data?.persoData));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getExpertbyId();
        //console.log('Data By ID',);
        //).slice(-2)
        console.log(dataExpert);
    }, []);

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{i18n.t('Gestion des Experts')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{nomExpert} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <DocAdministra type={location?.state?.type}/>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'85%':'100%',minWidth:device=='desktop'?'500px':'200px',alignItems: 'center',gap:'24px'}}>
                        <NavBarDonneeProfile type={location?.state?.type}/>
                        <SocieteGeneralisation
                            // typeTraitement={(location?.state?.type=='Actif'||typeof location?.state?.type=='undefined' ) ?
                            //     typeTraitementEnum.READ_ONLY : typeTraitementEnum.ADMIN_UPDATE_EXPERT}
                            //d'apres la demande de FZ -> Modifiez la logique de cette partie pour permettre à BO de modifier les données, même si l'expert est actif est actif.
                            typeTraitement={typeTraitementEnum.ADMIN_UPDATE_EXPERT}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
export default SocieteAdmin;